import Axios from 'axios'

import type {
  TAddCompanyToCompanyGroupResponse,
  TCompanyGroupDto,
  TCreateCompanyGroupRequest,
  TCreateCompanyGroupResponse,
  TGetCompanyStructureSyncStatusResponse,
  TRemoveCompanyFromCompanyGroupResponse,
  TUpdateCompanyGroupRequest,
  TUpdateCompanyGroupResponse
} from '@homepal/api-contract'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/company-groups`

export async function getAll() {
  return getWithRedirect<TCompanyGroupDto[]>(URL)
}

export async function create(name: string, company?: string) {
  const body: TCreateCompanyGroupRequest = { data: { name, company } }

  return Axios.post<TCreateCompanyGroupResponse>(
    URL,
    body,
    parseAuthenticationHeader()
  )
}

export async function update(
  id: string,
  name?: string,
  economySetId?: string | null
) {
  const body: TUpdateCompanyGroupRequest = { data: {} }

  if (name) {
    body.data.name = name
  }

  if (economySetId !== undefined) {
    body.data.economy_set_id = economySetId
  }

  return Axios.patch<TUpdateCompanyGroupResponse>(
    `${URL}/${id}`,
    body,
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}

export async function addCompanyToCompanyGroup(id: string, companyId: string) {
  return Axios.post<TAddCompanyToCompanyGroupResponse>(
    `${URL}/${id}/${companyId}`,
    {},
    parseAuthenticationHeader()
  )
}

export async function removeCompanyFromCompanyGroup(
  id: string,
  companyId: string
) {
  return Axios.delete<TRemoveCompanyFromCompanyGroupResponse>(
    `${URL}/${id}/${companyId}`,
    parseAuthenticationHeader()
  )
}

export async function getOntologySyncStatus() {
  return Axios.get<TGetCompanyStructureSyncStatusResponse>(
    `${URL}/ontology-sync-status`,
    parseAuthenticationHeader()
  )
}
